function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1007.4,111.1H446.7v102.3H161.3L0.4,501.2v272.5h96.4c15.9,74.4,82.2,130.4,161.3,130.4s145.3-56,161.3-130.4h27.4h69 h50.1c15.9,74.4,82.2,130.4,161.3,130.4s145.3-56,161.3-130.4h119.1V111.1z M353.9,739.2c0,52.9-43,95.9-95.9,95.9 s-95.9-43-95.9-95.9s43-95.9,95.9-95.9S353.9,686.3,353.9,739.2z M446.7,704.7h-27.4c-15.9-74.4-82.2-130.4-161.3-130.4 s-145.3,56-161.3,130.4H69.4V519.1l132.4-236.7h244.9V704.7z M822.9,739.2c0,52.9-43,95.9-95.9,95.9s-95.9-43-95.9-95.9 s43-95.9,95.9-95.9S822.9,686.3,822.9,739.2z M938.4,704.7h-50.1c-15.9-74.4-82.2-130.4-161.3-130.4s-145.3,56-161.3,130.4h-50.1 V213.5v-33.3h422.7V704.7z"
});

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1008 1008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.9dca2ca4.svg";
export { ForwardRef as ReactComponent };